import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import { Collapse, Button, Modal } from 'antd';
import stylesRiepilogo from '../Riepilogo.module.scss';
import Immagine from '../../../../components/Immagine/Immagine';


const { Panel } = Collapse;

const PanelPreventivo = (props) => {

    const datiPreventivo = useSelector(state => state.dataReducer.modello.datiPratica);
    const [visibleModal,setVisibleModal] = useState(false);
    const importo = applicaSeparatore(datiPreventivo.importo);
    const tan = convertNumberFloat(datiPreventivo.tan);
    const taeg = convertNumberFloat(datiPreventivo.taeg);
    const rata = convertNumberFloat(datiPreventivo.rata);

    function showModal(){
        setVisibleModal(!visibleModal);
    }

    function applicaSeparatore(importoNumerico){  
        var importo = importoNumerico.toString();  
        if(importo.length>3){  
          importo = importo.split('',importo.length).reverse().join('').replace(/([0-9]{3})/g,'$1.');  
          importo = importo.split('',importo.length).reverse().join('');  
        }  
        return importo;  
      }  

      function convertNumberFloat(number){
        return ((number).toFixed(2)).replace('.',',');
    }


    return (
        <>
        <Collapse expandIcon={({ isActive }) =>  isActive ? <Immagine urlImage={'menus.svg'} name="CLOSE" class={stylesRiepilogo.immagineCollapse} /> : <Immagine urlImage={'plus.svg'} name="OPEN" class={stylesRiepilogo.immagineCollapse} />  }>
            <Panel header={props.headerPanel} key={props.chiave}>
                    <div className={stylesRiepilogo.Riepilogo}>
                        <h3 className={stylesRiepilogo.titoloRiepilogo}>Dati</h3>
                        <Button onClick={() => props.tornaAlloStep(0)} className={stylesRiepilogo.TornoIndietro}>Modifica</Button>
                        <div className={stylesRiepilogo.tabellaRiepilogo}>
                            
                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                <div className={stylesRiepilogo.leftRiepilogo}>
                                    Importo
                                </div>
                                <div className={stylesRiepilogo.rightRiepilogo}>
                                    {importo},00€
                                </div>
                            </div>

                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                <div className={stylesRiepilogo.leftRiepilogo}>
                                    Durata
                                </div>
                                <div className={stylesRiepilogo.rightRiepilogo}>
                                    {datiPreventivo.numeroRate} mesi
                                </div>
                            </div>

                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                <div className={stylesRiepilogo.leftRiepilogo}>
                                    Progetto
                                </div>
                                <div className={stylesRiepilogo.rightRiepilogo}>
                                    {
                                    datiPreventivo.progetto === 'AUN' ? 'Auto' :
                                    datiPreventivo.progetto === 'CAM' ? 'Caravan/Camper' :
                                    datiPreventivo.progetto === 'VAC' ? 'Viaggi e Vacanze' :
                                    datiPreventivo.progetto === 'MOT' ? 'Moto' :
                                    datiPreventivo.progetto === 'ELE' ? 'Elettrodomestici/Elettronica' :
                                    datiPreventivo.progetto === 'RIS' ? 'Spese Ristrutturazione Casa' :
                                    datiPreventivo.progetto === 'MOB' ? 'Arredamento' :
                                    datiPreventivo.progetto === 'LIQ' ? 'Altri Progetti' :
                                    datiPreventivo.progetto === 'SST' ? 'Studio' :
                                    datiPreventivo.progetto === 'SSA' ? 'Cure e Interventi Sanitari' :
                                    null
                                    }
                                </div>
                            </div>
                            
                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                <div className={stylesRiepilogo.leftRiepilogo}>
                                    Assicurazione
                                </div>
                                <div className={stylesRiepilogo.rightRiepilogo}>
                                    {datiPreventivo.assicurazione === true ? 'SI' : 'NO'}
                                    <Immagine urlImage={'petroil.svg'} styleInline={{marginLeft:10}} name="info" clicked={showModal} />
                                </div>
                            </div>
                            
                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                <div className={stylesRiepilogo.leftRiepilogo}>
                                    TAN
                                </div>
                                <div className={stylesRiepilogo.rightRiepilogo}>
                                    {tan}%
                                </div>
                            </div>
                            
                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                <div className={stylesRiepilogo.leftRiepilogo}>
                                    TAEG
                                </div>
                                <div className={stylesRiepilogo.rightRiepilogo}>
                                    {taeg}%
                                </div>
                            </div>

                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                <div className={stylesRiepilogo.leftRiepilogo}>
                                    Rata
                                </div>
                                <div className={stylesRiepilogo.rightRiepilogo}>
                                    {rata}€/mese
                                </div>
                            </div>

                        </div>
                    </div>
                </Panel>
                </Collapse>
        
            <Modal
                onCancel={showModal}
                open={visibleModal}
                closeIcon={<Immagine urlImage={'close-modal.svg'} name='close' />}
                >
                <h2>Vuoi aggiungere un’assicurazione facoltativa?</h2>
                <p>Se lo desideri, è possibile sottoscrivere una copertura assicurativa che tuteli la tua persona in caso di imprevisti.</p>
                <p>Ti ricordiamo che l’assicurazione è facoltativa e non indispensabile per ottenere il finanziamento alle condizioni proposte.</p>
            </Modal>

    </>
    )
}

export default PanelPreventivo;